// app/customs/voicerecording/index.tsx
'use client';

import React, { useState, useEffect } from 'react';
import * as Global from '@/utils/global';
import axios from 'axios';
import { setglobalUserInfo, setListeningEngine, setListeningActive, setListeningTarget } from '@/utils/speechbyapi';
// import { setIndicatorColor } from '@/utils/speechbyapi';
import * as AuthContext from '@/utils/authcontext';
import ErrorMessage from '@/customs/errormessage';
import ReactDOM from "react-dom";
import './index.css';
import WaitingSpinner from '@/customs/waitingspinner';

type Props = {
  // 記録庫GUID: string;
  actionPkey:string
  onClose?: () => void; // ← 追加
};

const VoiceRecording: React.FC<Props> = (props) => {
  
  const [isListening, setIsListening] = useState(false);
  const [roles, setRoles] = useState<{ name: string; content: string; timestamp?: string }[]>([]);
  const {authToken, employeeGUID, employeeDomain} = AuthContext.useAuth();
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isRunning, setIsRunning] = useState(false);


  useEffect(() => {
    if (!employeeGUID || !props.actionPkey) return;
    loadHistory();
  }, [employeeGUID, props.actionPkey]);


  
  useEffect(() => {
    // employeeGUIDがまだ取得できていない場合、リスニング開始前、終了後はスキップ
    setListeningTarget('main-textbox', 'send-button', 'rec-indicator');
    setglobalUserInfo(employeeGUID, employeeDomain);
  }, [employeeGUID, employeeDomain]);  // 👈 依存配列に追加！

  useEffect(() => {
    // employeeGUIDがまだ取得できていない場合、リスニング開始前、終了後はスキップ
    if (!employeeGUID || !isListening) return;
    setListeningEngine(true);
    return () => setListeningEngine(false);
  }, [isListening]);  // 👈 依存配列に追加！

  useEffect(() => {
    const chatContainer = document.getElementById('chat-history');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [roles]);


  useEffect(() => {
    if (!isRunning) return;

    const timer = setInterval(() => {
      loadHistory();
    }, 3000); // 3秒おき

    return () => {
      clearInterval(timer);
    };
  }, [isRunning]);
  

  const toggleRecording = () => {
    const next = !isListening;
    setListeningTarget('main-textbox', 'send-button', 'rec-indicator');
    setIsListening(next);
    setListeningActive(next);
  };

  // ★ ここを追加：履歴読み込み関数を外へ出す
  const loadHistory = async () => {
    if (!employeeGUID || !props.actionPkey) return;

    try {
      const res = await axios.post(`${Global.getApiBaseUrl()}/voice_recording/voiceloader`, {
        // userid: employeeGUID,
        // 記録庫GUID: props.actionPkey

        base_interface: {
          user_guid: employeeGUID,
          user_domain: employeeDomain,
          ip_address: window.location.hostname,
          user_agent: navigator.userAgent,
        },
        body_data: {
          記録庫GUID: props.actionPkey
        }

      });

      if (Array.isArray(res.data)) {
        setRoles(
          res.data.map((item: any) => ({
            name: "利用者",
            content: item.text,
            timestamp: item.timestamp
          }))
        );
      }
    } catch (err) {
      console.error("履歴読み込み失敗:", err);
    }
  };

  const handleSend = async () => {
    const textbox = document.getElementById('main-textbox') as HTMLInputElement;
    const content = textbox?.value?.trim() || '';
    if (!content) return;

    try {
      // 即時に利用者メッセージをDOMへ追加（送信の手応えを即反映）
      const now = new Date().toLocaleString('ja-JP', { hour12: false });
      setRoles(prev => [...prev, { name: '利用者', content, timestamp: now }]);

      // DB書き込みリクエスト
      const res = await axios.post<any>(`${Global.getApiBaseUrl()}/voice_recording/voicewriter`, {
        // userid: employeeGUID,
        // 記録庫GUID: props.actionPkey,
        // text: content,

        base_interface: {
          user_guid: employeeGUID,
          user_domain: employeeDomain,
          ip_address: window.location.hostname,
          user_agent: navigator.userAgent,
        },
        body_data: {
          記録庫GUID: props.actionPkey,
          text: content,
        }

      });

      if (res.data?.status === 'ok') {
        textbox.value = '';           // 入力欄クリア
        setListeningActive(true);     // リスニング再開

      } else {
        throw new Error('書き込みに失敗しました');
      }

    } catch (err: any) {
      const message = err.response?.data?.detail || err.message || '不明なエラー';
      setErrorMessage(`送信に失敗しました||${message}`);
      setIsListening(false);         
      setListeningActive(false);
    }
  };


  const handleUploadWithFile = async (file: File) => {
    const formData = new FormData();
    const baseTokenInterface = Global.createBaseTokenInterface(authToken, employeeDomain);
    formData.append("token", baseTokenInterface.token);
    formData.append("user_domain", baseTokenInterface.user_domain);
    formData.append("ip_address", baseTokenInterface.ip_address);
    formData.append("user_agent", baseTokenInterface.user_agent);
    formData.append("pkey", props.actionPkey ?? "");
    formData.append("action_type", Global.SPREAD_ACTION_VOICE_RECORDING);
    formData.append("action_template", "");
    // formData.append("audio", file);
    formData.append("binary", file);
    setIsRunning(true); // ★ 実行開始
    try {
      const res = await axios.post<any>(
        // `${Global.getApiBaseUrl()}/voice_recording/bulk_trans_voice`,
        `${Global.getApiBaseUrl()}/spread_action`,
        formData,
        { timeout: Global.SPREAD_ACTION_TIMEOUT_MS }
      );
      if (res.data?.status === "ok") {
        setSelectedFile(null);
        const fileInput = document.getElementById("fileInput") as HTMLInputElement;
        if (fileInput) fileInput.value = "";
        // ★ 追加（ここだけ）
        loadHistory();
        alert("一括文字起こしにが完了しました。");
                
      } else {
        alert("文字起こしに失敗しました。");
      }
    } catch (err) {
      console.error("upload error:", err);
      alert("アップロードに失敗しました。");
    } finally {
      setIsRunning(false); // ★ 必ず解除
    }
  };

  return (
    <div className="voicerecording-container">
      {errorMessage && (
        <ErrorMessage message={errorMessage} onClose={() => setErrorMessage(undefined)} />
      )}

      { isRunning && (
        <WaitingSpinner message="一括文字起こしを実行しています…" />
      )}

      {props.onClose && (
        <p>voicerecording / 記録庫GUID：<strong>{props.actionPkey}</strong><button style={{width:'100px'}} onClick={props.onClose}>閉じる</button></p>
      )}

      {/* メッセージコンテナ */}
      <div className="chat-history" id="chat-history">
        {roles.map((r, idx) => (
          <div key={idx} className={`message-wrapper ${r.name === "利用者" ? "left" : "right"}`}>
            {/* <div className={`balloon ${r.name === "利用者" ? "balloon-left" : "balloon-right"}`}>
              <div}>{r.content}</div>
            </div> */}
            <div className={`balloon ${r.name === "利用者" ? "balloon-left" : "balloon-right"}`}>
              <div dangerouslySetInnerHTML={{ __html: r.content.replace(/\n/g, "<br>") }} />  
            </div>
            {r.timestamp && <div className="timestamp">{r.timestamp}</div>}
          </div>
        ))}
      </div>

      <div className="chat-input">
        <textarea className="main-textbox" id="main-textbox" placeholder="メッセージを入力..." />
        <div className="buttons">

          {/* ファイル選択ボタン */}
          <button
            className="file-select-button"
            onClick={() => document.getElementById("fileInput")?.click()}
          >
            🗃️選択
          </button>

          {/* 非表示の file input */}
          <input
            id="fileInput"
            type="file"
            accept="audio/*"
            style={{ display: "none" }}
            onChange={(e) => {
              if (!e.target.files?.length) return;

              const file = e.target.files[0];

              const ok = window.confirm("一括文字起こしを実行します。よろしいですか？");
              if (!ok) {
                // キャンセル時：input をリセット
                e.target.value = "";
                return;
              }

              setSelectedFile(file);

              // ★ 即アップロード実行
              setTimeout(() => {
                handleUploadWithFile(file);
              }, 0);
            }}
          />

          {/* ●マーク */}
          <div id="rec-indicator"></div>
          <button onClick={toggleRecording}>
            {isListening ? (
              <>
                🔈停止
              </>
            ) : (
              <>
                🎙音声
              </>
            )}
          </button>
          <button id="send-button" onClick={handleSend}>
            🛫送信
          </button>
          {/* <button onClick={loadHistory}>
            🔄️<br />更新
          </button> */}
        </div>
      </div>

    </div>
  );
};

export default VoiceRecording;
